/**
 * @file GnavSpの要素の表示・非表示
 *
 */
'use strict';

/**
 * @classname ToggleGnavSPView
 * @classdesc GnavSpの要素の表示・非表示
 */
export default class ToggleGnavSPView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('GnavSP.constructor');
		this._$e = $e;
		this._$container = this._$e.find('.container');
		this._$head = this._$e.find('.head');
		this._$icon = this._$e.find('.fa-angle-down');
		this._$head.on('click', () => this.onClick());
	}

	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof ToggleGnavSPView
	 * @return {undefined}
	 */
	onClick() {
		console.log('ToggleGnavSP.onClick');
		this._$container.stop().slideToggle();
		this._$icon.stop().toggleClass('rotate');
	}
}
